import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CourierToast, type CourierToastItemActionClickEvent, type CourierToastItemClickEvent } from '@trycourier/courier-react';

import { courierToastTheme } from './courierToastTheme';
import { useCourierAuth } from './useCourierAuth';

type AuthState = { auth?: { isAuthenticated?: boolean } };

const resolveHref = (message: CourierToastItemClickEvent['message']) => {
  const data = (message as { data?: Record<string, unknown> }).data ?? {};
  const actions = (message as { actions?: Array<{ href?: string }> }).actions ?? [];
  const fromAction = actions.find(a => a.href)?.href;
  const fromData = typeof data.href === 'string' ? data.href : undefined;
  const threadId = typeof data.threadId === 'string' ? data.threadId : undefined;
  return fromAction ?? fromData ?? (threadId ? `/inbox#thread=${threadId}` : '/inbox');
};

const NotificationToast = () => {
  const history = useHistory();
  const isAuthenticated = useSelector((state: AuthState) => state.auth?.isAuthenticated ?? false);

  if (!isAuthenticated) return null;
  return <AuthenticatedNotificationToast history={history} />;
};

const AuthenticatedNotificationToast = ({ history }: { history: ReturnType<typeof useHistory> }) => {
  const { isReady } = useCourierAuth();
  if (!isReady) return null;

  return (
    <CourierToast
      mode="light"
      lightTheme={courierToastTheme}
      darkTheme={courierToastTheme}
      autoDismiss
      autoDismissTimeoutMs={30000}
      onToastItemClick={({ message }: CourierToastItemClickEvent) => {
        history.push(resolveHref(message));
      }}
      onToastItemActionClick={({ action }: CourierToastItemActionClickEvent) => {
        if (action?.href) history.push(action.href);
      }}
    />
  );
};

export default NotificationToast;
